export default "__VITE_ASSET__e5a0d51f__"